import { createContext, useContext } from 'react'
import { UIStore } from './UIStore'
import { UserStore } from './UserStore'
import { ChatStore } from './ChatStore'
import { MessageStore } from './MessageStore'

export class RootStore {
  uiStore: UIStore
  userStore: UserStore
  chatStore: ChatStore
  messageStore: MessageStore

  constructor() {
    this.uiStore = new UIStore()
    this.userStore = new UserStore()
    this.chatStore = new ChatStore(this)
    this.messageStore = new MessageStore(this)
  }
}

const rootStore = new RootStore()

export const StoreContext = createContext(rootStore)

export const useStore = () => useContext(StoreContext)

export default rootStore
